import type { FormInstance, InputRef } from "antd";
import { useRef } from "react";

import { GlobalNewOpportunityModalContext } from "./index";

type GlobalNewOpportunityContextProviderProps = {
  children: React.ReactNode;
  form: FormInstance;
};

export default function GlobalNewOpportunityContextProvider({
  children,
  form,
}: GlobalNewOpportunityContextProviderProps) {
  const amountRef = useRef<HTMLInputElement | null>(null);
  const oppNameRef = useRef<InputRef | null>(null);
  const coreFieldsDivRef = useRef<HTMLDivElement | null>(null);

  return (
    <GlobalNewOpportunityModalContext.Provider
      value={{
        form,
        amountRef: amountRef as React.RefObject<HTMLInputElement>,
        oppNameRef: oppNameRef as React.RefObject<InputRef>,
        coreFieldsDivRef: coreFieldsDivRef as React.RefObject<HTMLDivElement>,
      }}
    >
      {children}
    </GlobalNewOpportunityModalContext.Provider>
  );
}
